import jQuery from 'jquery';
import 'slick-carousel';
/* eslint-disable no-console */
const HeroSlider = {
  onReady: () => {
    // eslint-disable-next-line no-unused-vars
    (function ($) {
      $('.site-content .hero-slider__slick').slick({
        dots: true,
        speed: 300,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 5000,
      });
    })(jQuery);
  },
};

export default HeroSlider;
